import React, { memo } from 'react';
import _ from 'lodash';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { Grid } from '@mui/material';
import { SimulationTypeEnum } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import TotalAmount from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/TotalAmount';
import { styled } from '@mui/material/styles';

import { KEY_INDICATORS_DEFAULT_HEIGHT } from 'routes/HumanResourcesModule/components/ui/constants';
import { TotalResultAmounts } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/helpers/types';
import SimulationResult from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/components/SimulationResult';

type Props = {
    hrSimulation: HrSimulation;
    isLoading: boolean;
    totalAmounts: TotalResultAmounts;
};

export const StyGridContainer = styled(Grid)`
    display: flex;
    flex-grow: 1;
`;

const KeysIndicators = ({
    hrSimulation,
    isLoading,
    totalAmounts,
}: Props): React.ReactElement => {
    const { type: simulationType } = hrSimulation;
    const isBudgetProposal =
        simulationType === SimulationTypeEnum.BUDGET_PROPOSAL;

    return (
        <Grid
            container
            spacing={2}
            sx={{ minHeight: KEY_INDICATORS_DEFAULT_HEIGHT }}
        >
            <Grid item xs={isBudgetProposal ? 2 : 3} sx={{ display: 'flex' }}>
                <StyGridContainer container spacing={2}>
                    <Grid item xs={12} sx={{ display: 'flex' }}>
                        <TotalAmount
                            totalAmounts={totalAmounts}
                            hrSimulation={hrSimulation}
                            isLoading={isLoading}
                        />
                    </Grid>
                </StyGridContainer>
            </Grid>
            <Grid item xs={isBudgetProposal ? 10 : 9} sx={{ display: 'flex' }}>
                <SimulationResult
                    isBudgetProposal={isBudgetProposal}
                    totalAmounts={totalAmounts}
                    hrSimulation={hrSimulation}
                    isLoading={isLoading}
                />
            </Grid>
        </Grid>
    );
};

export default memo(KeysIndicators, _.isEqual);
